<div id="component-ys-inner-{{ component.id }}"
  (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
<div class="ql-editor" [innerHtml]="htmlString   | safeHtml"></div></div>